<template>
  <div class="card-header dash-card-header row flex-shrink-0">
    
    <lambo-header-item  v-for="(item) in items"
                        :key="item.kpi"
                        :dashdata="dashdata"
                        :kpi="getKpiByString(item.kpi)"
                        :class="[ ...item.classes ]" />

  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import LamboHeaderItem from './LamboHeaderItem';
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      performanceitem,
      LamboHeaderItem
    },
    props: {
      items: Array
    },
    mixins: [ KpiMixin ]
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .dash-card-header {
    height: 90px !important;
  }

  .row-txt-l {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-right:solid 1px $lambo-header-border;
  }
  .row-txt-m {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-left:solid 1px $lambo-header-border;
    border-right:solid 1px $lambo-header-border;
  }
  .row-txt-r {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-left:solid 1px $lambo-header-border;
  }

  .row-txt-header {
    text-align: center;
    font-weight: bold;
    height: 48px;
  }
</style>
